import { isAppointment } from "@/features/appointments/utils";
import {
  type CoWorkerScheduleActivity,
  type OutlookEvent,
} from "@/features/calendar/types";
import { isOutlookEvent } from "@/features/calendar/useUserCalendar";
import {
  getAppointmentTitle,
  isScheduleActivity,
} from "@/features/calendar/utils";
import { type Appointment, type Task } from "@repo/api";
import { Name } from "@repo/ui";

export const normalizeItem = (
  item: OutlookEvent | Appointment | Task | CoWorkerScheduleActivity
) => {
  let startDate;
  let endDate;
  let itemTitle;
  let description;
  let allDay;

  if (isOutlookEvent(item)) {
    startDate = new Date(`${item.start.dateTime}+00:00`);
    endDate = new Date(`${item.end.dateTime}+00:00`);
    itemTitle = item.subject;
    allDay = item.isAllDay;
  } else if (isAppointment(item)) {
    allDay = false;
    startDate = new Date(item.timeWindowStartTime);
    endDate = new Date(item.timeWindowEndTime);
    itemTitle = getAppointmentTitle(item);
    description = (
      <Name
        firstName={item.customer.firstName}
        lastName={item.customer.lastName}
      />
    );
  } else if (isScheduleActivity(item)) {
    itemTitle = item.title;
    startDate = item.start;
    endDate = item.end;
    allDay = false;
  } else {
    allDay = !item.isTimeSet;
    startDate = item.taskStartDateTime
      ? new Date(item.taskStartDateTime)
      : undefined;
    endDate = item.taskEndDateTime ? new Date(item.taskEndDateTime) : undefined;
    itemTitle = item.title;
    description = item.description;
  }

  return { startDate, endDate, itemTitle, description, allDay };
};
